module.exports = __webpack_public_path__ + "static/sm-post_c-9ea207e7d1c77117729794c242a2cded.png";